/**
 * DueDateBadge — Anzeige des Projekt-Fälligkeitsdatums auf Karten (Atlas, Board).
 * Quelle: Plan 2026-05-16. Überfällig nur wenn lifecycle=active.
 */
import type { LifecycleStatus } from '@projektverwaltung/shared';
import { useTranslation } from 'react-i18next';
import { Badge } from './badge.js';

export function DueDateBadge({
  dueDate,
  lifecycleStatus,
}: {
  dueDate: string | null | undefined;
  lifecycleStatus: LifecycleStatus;
}) {
  const { t, i18n } = useTranslation();
  if (!dueDate) return null;

  const formatted = new Intl.DateTimeFormat(i18n.language, { dateStyle: 'short' }).format(
    new Date(dueDate),
  );
  const todayIso = new Date().toISOString().slice(0, 10);
  const isOverdue = lifecycleStatus === 'active' && dueDate < todayIso;
  const label = t('v2.duedate.due_on', 'fällig {{date}}', { date: formatted });

  if (isOverdue) return <Badge tone="danger">{label}</Badge>;

  return (
    <span className="text-[10px]" style={{ color: 'var(--ink-3)', fontFamily: 'var(--f-mono)' }}>
      {label}
    </span>
  );
}
